/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AddFeedbackClassStudentsRequestViewModel } from "../types/AddFeedbackClassStudentsRequestViewModel.ts";

export const addFeedbackClassStudentsRequestViewModelSchema = z.object({
  classStudentIds: z.array(z.number().int()).nullish(),
}) as unknown as ToZod<AddFeedbackClassStudentsRequestViewModel>;
